import { render } from "./StaffComponent.vue?vue&type=template&id=43bd2598"
import script from "./StaffComponent.vue?vue&type=script&lang=js"
export * from "./StaffComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__